export const CHANGE_USER_PROFILE_REQUEST = 'CHANGE_USER_PROFILE_REQUEST';
export const CHANGE_USER_PROFILE_SUCCESS = 'CHANGE_USER_PROFILE_SUCCESS';
export const CHANGE_USER_PROFILE_FAILURE = 'CHANGE_USER_PROFILE_FAILURE';



// WEBPACK FOOTER //
// ./src/modules/UserManagement/User_profile/redux/constants/user_profile.constants.js